export default "__VITE_ASSET__DJ3SH6Jj__"